export const BASE_AUTH_URL = "";